import React, { Component } from "react";
import "./CommonTabStyles.css";

// NavigationBar component
export class CommonTabs extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  handleTabClick = (tab) => {
    this.props.onTabChange(tab);
  };

  render() {
    const { tabs, Column, selectedTab } = this.props;

    return (
      <div className="Common-nav-bar1" style={{ ...(Column && { flexDirection: "column" }) }}>
        {tabs.map((tab) => (
          <button
            style={{ ...(Column && { width: "100%", marginBlockEnd: "10px" }) }}
            key={tab.id}
            onClick={() => this.handleTabClick(tab)}
            className={`Common-nav-tab1 ${selectedTab === tab.id ? "Common-nav-tab-active1" : ""}`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TabBarCompoenent/CommonTabs.jsx